import { equipmentService } from './equipmentService';

export const trackUserEvent = (parameters) => {
    if (!window.dataLayer) return;

    const { equipment_id, maintenance_planner_group, company_code } = equipmentService.getEquipment() || {};
    const extParameters = {
        ...parameters,
        ...(equipment_id && { equipment_number: equipment_id }),
        ...(maintenance_planner_group && { planner_group: maintenance_planner_group }),
        ...(company_code && { company_code: company_code }),
    };

    window.dataLayer.push({
        event: 'userEvent',
        ...extParameters,
    });
};

export const trackPerformance = (trackerName, startTime, endTime) => {
    if (!window.dataLayer) return;

    const duration = Math.round(endTime - startTime);

    window.dataLayer.push({
        event: 'performanceMetric',
        tracker: trackerName,
        duration: duration
    });
}

export const createPerformanceTracker = (trackerName) => {
    const startTime = performance.now();

    return {
        end: () => {
            const endTime = performance.now();
            trackPerformance(trackerName, startTime, endTime);
        }
    };
};